/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disable-style[_ngcontent-%COMP%]{background-color:#e9ecef!important;opacity:1!important}.set-middle[_ngcontent-%COMP%]{padding-top:9px;padding-left:54px}\n/*# sourceMappingURL=certificates-row.component.css.map*/"];
export { styles as styles };
